<google-map width="100%" height="120px" [center]="position" [zoom]="zoom" (mapClick)="moveMarker($event)">
  <map-marker [position]="position"> </map-marker>
</google-map>
